import { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import ModalInstruction from '../../ModalInstruction';
import { getText } from '../../../utils/languageUtils';

const FillInTheBlanks = ({ question: mainQuestion, selectedOptions, setSelectedOptions, answer, language, isMarked }) => {
  const [selectedOption, setSelectedOption] = useState(selectedOptions?.id || '');
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const correctOptionId = mainQuestion.correct_option[0]?.id;

  useEffect(() => {
    if (isMarked && answer?.course_module_item?.[0]?.option_marked) {
      setSelectedOption(answer?.course_module_item?.[0]?.option_marked?.id);
    }
  }, [answer, isMarked]);

  const handleOptionChange = (option) => {
    setSelectedOption(option.id);
    setSelectedOptions({ id: option.id });
  };

 const renderSentence = () => {
  const sentence = getText(mainQuestion.question_title, language);
  const answerData = answer?.course_module_item?.[0];
  const correctOptionId = mainQuestion.correct_option?.[0]?.id;

  let idToUse = selectedOption;
  let color = '#6c757d'; // default

  if (isMarked && answerData?.option_marked?.id) {
    idToUse = answerData.option_marked.id;
    color = answerData.option_marked.id === correctOptionId ? '#007B19' : '#F62020';
  } else if (selectedOption) {
    color = '#007bff';
  }

  const selectedObj = mainQuestion.question_option.find(opt => opt.id === idToUse);
  const selectedText = getText(selectedObj?.title, language);

  const words = selectedText.split(',').map(word => word.trim());

  let filledSentence = sentence;
  let blankIndex = 0;

  // Replace each __BLANK__ one by one
  filledSentence = filledSentence.replace(/__BLANK__/g, () => {
    const word = words[blankIndex] || '______';
    blankIndex++;
    return `<strong style="color:${color}">${word}</strong>`;
  });

  return parse(filledSentence);
};




  return (
    <div>
      <div className="justify-content-end d-flex">
        <div onClick={handleShow}>
          <img
            src={require("../../../assets/images/instructions.png")}
            className="mobielViewIcon"
            alt="instructions"
          />
        </div>
      </div>
      <div className="col-12 mb-3">
        <div className="sectionsBox text-center">
          <p className="mb-0 text-center">{getText(mainQuestion.title, language)}</p>
        </div>
      </div>
      <div className='col-12 mb-3'>
        <p className="mb-0">{renderSentence()}</p>
      </div>
      {getText(mainQuestion.description, language)?.length > 0 && (
        <div className="col-12 mb-4">
          <div className="contentbox">
            <div className="content_safty">
              {parse(getText(mainQuestion.description, language))}
            </div>
          </div>
        </div>
      )}



      <div className="col-12">
        <form className="single-type pt-4">
          <div className="row justify-content-center text-center singleRadiotext">
            {mainQuestion.question_option.map((option, index) => {
              const isSelected = Number(selectedOption) === option.id;
              const isCorrect = Number(option.id) === Number(correctOptionId);
              const userMarked = Number(answer?.course_module_item?.[0]?.option_marked?.id) === Number(option.id);

              
              return (
                <label key={index}>
                  <input
                    type="radio"
                    name="option"
                    value={option.id}
                    checked={isSelected}
                    disabled={isMarked === 1}
                    onChange={() => handleOptionChange(option)}
                  />
                  <span>{getText(option.title, language)}</span>

                  {isMarked === 1 && userMarked && isCorrect && (
                    <FontAwesomeIcon icon={faCircleCheck} size="lg" color="#007B19" className="ms-2 mt-1" />
                  )}
                  {isMarked === 1 && userMarked && !isCorrect && (
                    <FontAwesomeIcon icon={faCircleXmark} size="lg" color="#F62020" className="ms-2 mt-1" />
                  )}
                </label>
              );
            })}
          </div>
        </form>
      </div>

      <ModalInstruction
        show={show}
        handleClose={handleClose}
        inst={parse(getText(mainQuestion.instruction, language))}
      />
    </div>
  );
};

export default FillInTheBlanks;
